import { render, staticRenderFns } from "./UpgradeTipsDialog.vue?vue&type=template&id=d4389340&scoped=true&"
import script from "./UpgradeTipsDialog.vue?vue&type=script&lang=js&"
export * from "./UpgradeTipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeTipsDialog.vue?vue&type=style&index=0&id=d4389340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4389340",
  null
  
)

export default component.exports